import { connect } from 'react-redux';

import SelectedColumnListComponent from './Component';

const mapStateToProps = state => {
  return {
    selectedStats: state.selectedStats
  };
};

export default connect(mapStateToProps)(SelectedColumnListComponent);
